/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_S2_TInputs */

const en_mk_abt_s2_t = /** @type {(inputs: Mk_Abt_S2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smoothing the day-to-day`)
};

const id_mk_abt_s2_t = /** @type {(inputs: Mk_Abt_S2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memperhalus pemakaian sehari-hari`)
};

/**
* | output |
* | --- |
* | "Smoothing the day-to-day" |
*
* @param {Mk_Abt_S2_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_s2_t = /** @type {((inputs?: Mk_Abt_S2_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_S2_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_s2_t(inputs)
	return en_mk_abt_s2_t(inputs)
});